export * from "./PointsTrigger";
